import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const experiences = [
  {
    icon: 'ri-checkbox-circle-fill',
    color: '#3DCC78',
    bg: 'rgba(61,204,120,0.1)',
    title: 'Chegada segura',
    description: 'Ambiente tranquilo e guiado.',
  },
  {
    icon: 'ri-brain-line',
    color: '#00C8E8',
    bg: 'rgba(0,200,232,0.1)',
    title: 'Entendimento simples',
    description: 'Explicação clara do que acontece com sua mente.',
  },
  {
    icon: 'ri-headphone-line',
    color: '#F5A520',
    bg: 'rgba(245,165,32,0.1)',
    title: 'Experiência guiada',
    description: 'Áudio terapêutico conduzido.',
  },
  {
    icon: 'ri-leaf-line',
    color: '#3DCC78',
    bg: 'rgba(61,204,120,0.1)',
    title: 'Desaceleração do corpo',
    description: 'Seu sistema nervoso começa a sair do estado de alerta.',
  },
  {
    icon: 'ri-sparkling-line',
    color: '#F5A520',
    bg: 'rgba(245,165,32,0.1)',
    title: 'Orientação prática',
    description: 'Exercício simples para continuar durante a semana.',
  },
];

export default function ExperienceSimulation() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="py-24 px-6" style={{ background: '#060D18' }}>
      <div
        ref={ref}
        className="max-w-3xl mx-auto"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(28px)',
          transition: 'opacity 0.7s ease, transform 0.7s ease',
        }}
      >
        <div className="text-center mb-14">
          <span
            className="inline-block text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-6 border"
            style={{ background: 'rgba(0,200,232,0.08)', color: '#00C8E8', borderColor: 'rgba(0,200,232,0.2)' }}
          >
            Dentro da sessão
          </span>
          <h2 className="text-3xl md:text-4xl font-semibold text-white">
            Como é a experiência da sessão
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {experiences.map((exp, i) => (
            <div
              key={exp.title}
              className="flex items-start gap-4 rounded-2xl p-6 border"
              style={{
                background: '#0F1E30',
                borderColor: 'rgba(0,200,232,0.12)',
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(20px)',
                transition: `opacity 0.5s ease ${i * 0.1}s, transform 0.5s ease ${i * 0.1}s`,
              }}
            >
              <span
                className="w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0"
                style={{ background: exp.bg }}
              >
                <i className={`${exp.icon} text-xl`} style={{ color: exp.color }} />
              </span>
              <div>
                <p className="font-semibold text-base mb-1 text-white">{exp.title}</p>
                <p className="text-sm" style={{ color: '#7A9BB5' }}>{exp.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}